/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface ShipmentResponseObject {
  shipment: {
    id: number
  }
}

export interface VerifyShipmentResponseObject {
  shipment: {
    id: number
    stops: {
      city: string
      stateCode: string
      date: string
      displayTimezone: string
      stopType: string
    }[]
  }
}

export interface IBulkShipmentResponse {
  shipments: {
    id: number
    errors: string[]
  }[]
}

export interface ErrorResponseObject {
  errors: string[]
}

export interface TrackingOverview {
  calculatedTrackingMethod?: {
    value?: string
    lastPingAt?: string | null
    isDriverTracking?: boolean
    driverLocationTimezone?: string | null
  }
  trackingRequirement?: number
  selectedTrackingMethod?: string | null
  truckNumber?: {
    value?: string | null
    project44Validated?: boolean
    keepTruckinValidated?: boolean
  }
  dispatcher?: {
    parentUserId?: number
    name?: string
    phone?: string
    email?: string
  }
  driver?: {
    parentUserId?: number
    name?: string
    phone?: string
    lastPingAt?: string | null
    isDriverTracking?: boolean
    driverLocationTimezone?: string | null
  }
  carrier?: {
    id?: number
  }
  trackingCapabilities?: {
    mobile?: boolean
    project44?: boolean
    keepTruckin?: boolean
  }
}

export interface QuickIssueFiltersCountResponse {
  quickIssueFiltersCount?: {
    pending?: number
    awaitingResponse?: number
    inProgress?: number
    resolved?: number
  }[]
}

export interface QuickIssueFiltersCountRequestBody {
  filters?: {
    afterHours?: boolean
    backhaulEligible?: boolean
    deliveryCity?: string
    deliveryDate?: string
    deliveryEndDate?: string
    deliveryMiles?: string
    deliveryRegions?: string
    deliveryStateCode?: string
    dropTrailer?: boolean
    equipment?: { [key: string]: any }
    hasClaims?: boolean
    hasHot?: boolean
    hasRolled?: boolean
    inComplianceReview?: boolean
    multiDay?: boolean
    needsComplianceReview?: boolean
    needsTracking?: boolean
    noAppointmentTime?: boolean
    pickupCity?: string
    pickupDate?: string
    pickupEndDate?: string
    pickupMiles?: string
    pickupRegions?: string
    pickupStateCode?: string
    podIds?: number[]
    query?: string
    shipperRateType?: string[]
    stateOptions?: string
    status?: string[]
    unconfirmedAppointment?: string
    usersId?: string
    usersType?: string
  }
}

export type QuickIssueFiltersCountProps = Omit<
  MutateProps<
    QuickIssueFiltersCountResponse,
    unknown,
    void,
    QuickIssueFiltersCountRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Quick issue filters count
 */
export const QuickIssueFiltersCount = (props: QuickIssueFiltersCountProps) => (
  <Mutate<QuickIssueFiltersCountResponse, unknown, void, QuickIssueFiltersCountRequestBody, void>
    verb='POST'
    path='/v9/shipments/quick_issue_filters_count'
    {...props}
  />
)

export type UseQuickIssueFiltersCountProps = Omit<
  UseMutateProps<
    QuickIssueFiltersCountResponse,
    unknown,
    void,
    QuickIssueFiltersCountRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Quick issue filters count
 */
export const useQuickIssueFiltersCount = (props: UseQuickIssueFiltersCountProps) =>
  useMutate<QuickIssueFiltersCountResponse, unknown, void, QuickIssueFiltersCountRequestBody, void>(
    'POST',
    `/v9/shipments/quick_issue_filters_count`,
    props
  )

export interface BulkAcceptShipmentsRequestBody {
  shipmentIds?: number[]
}

export type BulkAcceptShipmentsProps = Omit<
  MutateProps<
    IBulkShipmentResponse,
    ErrorResponseObject,
    void,
    BulkAcceptShipmentsRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Bulk accept shipments
 */
export const BulkAcceptShipments = (props: BulkAcceptShipmentsProps) => (
  <Mutate<IBulkShipmentResponse, ErrorResponseObject, void, BulkAcceptShipmentsRequestBody, void>
    verb='POST'
    path='/v9/shipments/bulk_accept'
    {...props}
  />
)

export type UseBulkAcceptShipmentsProps = Omit<
  UseMutateProps<
    IBulkShipmentResponse,
    ErrorResponseObject,
    void,
    BulkAcceptShipmentsRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Bulk accept shipments
 */
export const useBulkAcceptShipments = (props: UseBulkAcceptShipmentsProps) =>
  useMutate<IBulkShipmentResponse, ErrorResponseObject, void, BulkAcceptShipmentsRequestBody, void>(
    'POST',
    `/v9/shipments/bulk_accept`,
    props
  )

export interface BulkRejectShipmentsRequestBody {
  shipmentIds?: number[]
}

export type BulkRejectShipmentsProps = Omit<
  MutateProps<
    IBulkShipmentResponse,
    ErrorResponseObject,
    void,
    BulkRejectShipmentsRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Bulk reject shipments
 */
export const BulkRejectShipments = (props: BulkRejectShipmentsProps) => (
  <Mutate<IBulkShipmentResponse, ErrorResponseObject, void, BulkRejectShipmentsRequestBody, void>
    verb='POST'
    path='/v9/shipments/bulk_reject'
    {...props}
  />
)

export type UseBulkRejectShipmentsProps = Omit<
  UseMutateProps<
    IBulkShipmentResponse,
    ErrorResponseObject,
    void,
    BulkRejectShipmentsRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Bulk reject shipments
 */
export const useBulkRejectShipments = (props: UseBulkRejectShipmentsProps) =>
  useMutate<IBulkShipmentResponse, ErrorResponseObject, void, BulkRejectShipmentsRequestBody, void>(
    'POST',
    `/v9/shipments/bulk_reject`,
    props
  )

export interface ApprovePODQueryParams {
  /**
   * A boolean flag that bi-passes sending emails if set to true.
   */
  skipEmail?: boolean
}

export interface ApprovePODPathParams {
  /**
   * The id of the shipment the operation will be perform for. Refers to `shipments.id` in the database.
   */
  shipmentId: number
}

export type ApprovePODProps = Omit<
  MutateProps<
    ShipmentResponseObject,
    ErrorResponseObject,
    ApprovePODQueryParams,
    void,
    ApprovePODPathParams
  >,
  'path' | 'verb'
> &
  ApprovePODPathParams

/**
 * Approve POD
 *
 * Sets the ready_to_invoice_at and ready_to_bill_at and sends emails
 */
export const ApprovePOD = ({ shipmentId, ...props }: ApprovePODProps) => (
  <Mutate<
    ShipmentResponseObject,
    ErrorResponseObject,
    ApprovePODQueryParams,
    void,
    ApprovePODPathParams
  >
    verb='PUT'
    path={`/v9/shipments/${shipmentId}/approve_pod`}
    {...props}
  />
)

export type UseApprovePODProps = Omit<
  UseMutateProps<
    ShipmentResponseObject,
    ErrorResponseObject,
    ApprovePODQueryParams,
    void,
    ApprovePODPathParams
  >,
  'path' | 'verb'
> &
  ApprovePODPathParams

/**
 * Approve POD
 *
 * Sets the ready_to_invoice_at and ready_to_bill_at and sends emails
 */
export const useApprovePOD = ({ shipmentId, ...props }: UseApprovePODProps) =>
  useMutate<
    ShipmentResponseObject,
    ErrorResponseObject,
    ApprovePODQueryParams,
    void,
    ApprovePODPathParams
  >(
    'PUT',
    (paramsInPath: ApprovePODPathParams) => `/v9/shipments/${paramsInPath.shipmentId}/approve_pod`,
    { pathParams: { shipmentId }, ...props }
  )

export interface VerifyShipmentQueryParams {
  /**
   * The encoded id of the shipment the operation will be performed for. Refers to `shipments.id` in the database.
   */
  encodedShipmentId: string
}

export type VerifyShipmentProps = Omit<
  GetProps<VerifyShipmentResponseObject, ErrorResponseObject, VerifyShipmentQueryParams, void>,
  'path'
>

/**
 * Verify Shipment
 *
 * Takes an encoded shipment ID and returns the pickup and drop-off information for the shipment
 */
export const VerifyShipment = (props: VerifyShipmentProps) => (
  <Get<VerifyShipmentResponseObject, ErrorResponseObject, VerifyShipmentQueryParams, void>
    path='/v9/verify_shipment'
    {...props}
  />
)

export type UseVerifyShipmentProps = Omit<
  UseGetProps<VerifyShipmentResponseObject, ErrorResponseObject, VerifyShipmentQueryParams, void>,
  'path'
>

/**
 * Verify Shipment
 *
 * Takes an encoded shipment ID and returns the pickup and drop-off information for the shipment
 */
export const useVerifyShipment = (props: UseVerifyShipmentProps) =>
  useGet<VerifyShipmentResponseObject, ErrorResponseObject, VerifyShipmentQueryParams, void>(
    `/v9/verify_shipment`,
    props
  )

export interface TrackingOverviewPathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
}

export type TrackingOverviewProps = Omit<
  GetProps<TrackingOverview, TrackingOverview, void, TrackingOverviewPathParams>,
  'path'
> &
  TrackingOverviewPathParams

/**
 * Shipment Tracking Overview
 */
export const TrackingOverview = ({ shipmentId, ...props }: TrackingOverviewProps) => (
  <Get<TrackingOverview, TrackingOverview, void, TrackingOverviewPathParams>
    path={`/v9/shipments/${shipmentId}/tracking_overview`}
    {...props}
  />
)

export type UseTrackingOverviewProps = Omit<
  UseGetProps<TrackingOverview, TrackingOverview, void, TrackingOverviewPathParams>,
  'path'
> &
  TrackingOverviewPathParams

/**
 * Shipment Tracking Overview
 */
export const useTrackingOverview = ({ shipmentId, ...props }: UseTrackingOverviewProps) =>
  useGet<TrackingOverview, TrackingOverview, void, TrackingOverviewPathParams>(
    (paramsInPath: TrackingOverviewPathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/tracking_overview`,
    { pathParams: { shipmentId }, ...props }
  )
